import { render } from "./App.vue?vue&type=template&id=b7ddf662"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b7ddf662&lang=scss"

import exportComponent from "/Users/l/projects/Notik/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__